import {NextSeo} from "next-seo";
import {OpenGraph, Twitter} from "next-seo/lib/types";
import DefaultSeo from "@/next-seo.config";
import {useRouter} from "next/router";
import publicRuntimeConfig from "@FRAMEWORK/config/public";

export interface Seo {
	url?: string;
	description?: string;
	imageUrl?: string;
	canonical?: string;
	openGraph: OpenGraph;
	twitter: Twitter;
	keywords?: string;
}

const SEOWrapper = ({seo}: {seo?: Seo}) => {
	const router = useRouter();
	const defaultCanonicalPath = `${publicRuntimeConfig.ENV_PRODUCT_URL}${router.asPath}`;
	if (!seo) return <NextSeo {...{...DefaultSeo, canonical: defaultCanonicalPath}} />;
	if (!seo?.imageUrl) {
		seo.imageUrl = `https://static.ybtour.com/images/YB_metatag.jpg`;
	}
	const {
		canonical = defaultCanonicalPath,
		url = defaultCanonicalPath,
		openGraph = DefaultSeo.openGraph,
		twitter = DefaultSeo.twitter,
		description,
		keywords,
	} = seo;

	return (
		<NextSeo
			{...{...DefaultSeo, canonical, description}}
			openGraph={{
				...openGraph,
				url,
			}}
			twitter={{...twitter}}
			additionalMetaTags={[{name: "keywords", content: keywords ?? ""}]}
		/>
	);
};

export default SEOWrapper;
